import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { lambda_type, tuple_type, float64_type, int32_type, option_type, record_type, list_type, string_type, union_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { singleton, collect, append, tryItem, tryHead, empty } from "../../../fable_modules/fable-library-js.4.19.3/List.js";
import { Common_floatToDegrees, Visualization_UnifiedDistanceBranch_$reflection, Visualization_Centerline_$reflection } from "../../../RAWMap.Models/Common.js";
import { Bindings_PlaneIdentifier_Id_Z3EBB1C36, UnifiedTransitionBranchPointSelectionViewModel, UnifiedBranchRangeSelectionViewModel$1, Bindings_PlaneIdentifier_$reflection, Bindings_PlaneIdentifier, CenterlineMeasurementValueViewModel, UnifiedBranchAngleSelectionViewModel$1_$reflection, UnifiedBranchRangeSelectionViewModel$1_$reflection, LocalDiameterViewModel_$reflection, UnifiedTransitionBranchPointSelectionViewModel_$reflection } from "../../../RAWMap.Models/View/CenterlineMeasurement.js";
import { ofList, FSharpMap__TryFind, FSharpMap__Add, empty as empty_1 } from "../../../fable_modules/fable-library-js.4.19.3/Map.js";
import { comparePrimitives, equals, round, compare } from "../../../fable_modules/fable-library-js.4.19.3/Util.js";
import { bind, defaultArg, orElse, value as value_1, map } from "../../../fable_modules/fable-library-js.4.19.3/Option.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.3/Result.js";
import { ErrorMessage } from "../../../RAWMap.Models/ErrorMessage.js";
import { endsWith } from "../../../fable_modules/fable-library-js.4.19.3/String.js";
import { ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Return_1505, ResultComputationExpression_ResultBuilder__Bind_764BA1D3, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF, Result_bind } from "../../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { min } from "../../../fable_modules/fable-library-js.4.19.3/Double.js";

export class Bounds extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TransitionTrunk", "TransitionLeft", "TransitionRight", "DistanceTrunkCusp", "DistanceTrunk", "DistanceLeft", "DistanceRight"];
    }
}

export function Bounds_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.Bounds", [], Bounds, () => [[], [], [], [], [], [], []]);
}

export function Bounds_parse_Z721C83C5(value) {
    switch (value) {
        case "TransitionTrunk":
            return new Bounds(0, []);
        case "TransitionLeft":
            return new Bounds(1, []);
        case "TransitionRight":
            return new Bounds(2, []);
        case "DistanceTrunk":
            return new Bounds(4, []);
        case "DistanceTrunkCusp":
            return new Bounds(3, []);
        case "DistanceLeft":
            return new Bounds(5, []);
        case "DistanceRight":
            return new Bounds(6, []);
        default:
            throw new Error(`Unable to parse bounds ${value}`);
    }
}

export function Bounds_getBoundsFromUpdater(updater, bounds) {
    const wallBounds = updater.getUnifiedBranchIndexBounds().wallBounds;
    switch (bounds.tag) {
        case 1:
            return wallBounds.transitionLeftBranch;
        case 2:
            return wallBounds.transitionRightBranch;
        case 4:
            return wallBounds.distanceTrunk;
        case 3:
            return wallBounds.distanceTrunkCusp;
        case 5:
            return wallBounds.distanceLeftBranch;
        case 6:
            return wallBounds.distanceRightBranch;
        default:
            return wallBounds.transitionTrunk;
    }
}

export class RelatedMeasurementNames extends Record {
    constructor(FirstPlaneNames, SecondPlaneNames, ThirdPlaneNames) {
        super();
        this.FirstPlaneNames = FirstPlaneNames;
        this.SecondPlaneNames = SecondPlaneNames;
        this.ThirdPlaneNames = ThirdPlaneNames;
    }
}

export function RelatedMeasurementNames_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.RelatedMeasurementNames", [], RelatedMeasurementNames, () => [["FirstPlaneNames", list_type(string_type)], ["SecondPlaneNames", list_type(string_type)], ["ThirdPlaneNames", list_type(string_type)]]);
}

export function RelatedMeasurementNames_get_empty() {
    return new RelatedMeasurementNames(empty(), empty(), empty());
}

export class MeasurementInfo extends Record {
    constructor(MeasurementName, RelatedMeasurementNames, MeasurementBounds, CenterlineType) {
        super();
        this.MeasurementName = MeasurementName;
        this.RelatedMeasurementNames = RelatedMeasurementNames;
        this.MeasurementBounds = MeasurementBounds;
        this.CenterlineType = CenterlineType;
    }
}

export function MeasurementInfo_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.MeasurementInfo", [], MeasurementInfo, () => [["MeasurementName", string_type], ["RelatedMeasurementNames", RelatedMeasurementNames_$reflection()], ["MeasurementBounds", list_type(Bounds_$reflection())], ["CenterlineType", Visualization_Centerline_$reflection()]]);
}

export class LengthMeasurementInfo extends Record {
    constructor(MeasurementName, RelatedMeasurementNames, MeasurementBounds, TopCenterlineType, BottomCenterlineType) {
        super();
        this.MeasurementName = MeasurementName;
        this.RelatedMeasurementNames = RelatedMeasurementNames;
        this.MeasurementBounds = MeasurementBounds;
        this.TopCenterlineType = TopCenterlineType;
        this.BottomCenterlineType = BottomCenterlineType;
    }
}

export function LengthMeasurementInfo_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.LengthMeasurementInfo", [], LengthMeasurementInfo, () => [["MeasurementName", string_type], ["RelatedMeasurementNames", RelatedMeasurementNames_$reflection()], ["MeasurementBounds", list_type(Bounds_$reflection())], ["TopCenterlineType", Visualization_Centerline_$reflection()], ["BottomCenterlineType", Visualization_Centerline_$reflection()]]);
}

export class MidpointMeasurementInfo extends Record {
    constructor(MeasurementName, MeasurementBounds, MidpointBounds, CenterlineType) {
        super();
        this.MeasurementName = MeasurementName;
        this.MeasurementBounds = MeasurementBounds;
        this.MidpointBounds = MidpointBounds;
        this.CenterlineType = CenterlineType;
    }
}

export function MidpointMeasurementInfo_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.MidpointMeasurementInfo", [], MidpointMeasurementInfo, () => [["MeasurementName", string_type], ["MeasurementBounds", list_type(Bounds_$reflection())], ["MidpointBounds", list_type(string_type)], ["CenterlineType", Visualization_Centerline_$reflection()]]);
}

export class OffsetMeasurementInfo extends Record {
    constructor(MeasurementName, MeasurementBounds, OffsetMeasurementName, OffsetAmount, CenterlineType) {
        super();
        this.MeasurementName = MeasurementName;
        this.MeasurementBounds = MeasurementBounds;
        this.OffsetMeasurementName = OffsetMeasurementName;
        this.OffsetAmount = (OffsetAmount | 0);
        this.CenterlineType = CenterlineType;
    }
}

export function OffsetMeasurementInfo_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.OffsetMeasurementInfo", [], OffsetMeasurementInfo, () => [["MeasurementName", string_type], ["MeasurementBounds", list_type(Bounds_$reflection())], ["OffsetMeasurementName", option_type(string_type)], ["OffsetAmount", int32_type], ["CenterlineType", Visualization_Centerline_$reflection()]]);
}

export class CArmAngleViewModel extends Record {
    constructor(FirstAngle, SecondAngle, MeasurementFocus) {
        super();
        this.FirstAngle = FirstAngle;
        this.SecondAngle = SecondAngle;
        this.MeasurementFocus = MeasurementFocus;
    }
}

export function CArmAngleViewModel_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.CArmAngleViewModel", [], CArmAngleViewModel, () => [["FirstAngle", float64_type], ["SecondAngle", float64_type], ["MeasurementFocus", string_type]]);
}

export class StentMeasurement extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Diameter", "OffsetDiameter", "MidpointDiameter", "Length", "Angle", "CArmAngle"];
    }
}

export function StentMeasurement_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.StentMeasurement", [], StentMeasurement, () => [[["Item1", MeasurementInfo_$reflection()], ["Item2", tuple_type(UnifiedTransitionBranchPointSelectionViewModel_$reflection(), LocalDiameterViewModel_$reflection())]], [["Item1", OffsetMeasurementInfo_$reflection()], ["Item2", tuple_type(UnifiedTransitionBranchPointSelectionViewModel_$reflection(), LocalDiameterViewModel_$reflection())]], [["Item1", MidpointMeasurementInfo_$reflection()], ["Item2", tuple_type(UnifiedTransitionBranchPointSelectionViewModel_$reflection(), LocalDiameterViewModel_$reflection())]], [["Item1", LengthMeasurementInfo_$reflection()], ["Item2", tuple_type(UnifiedBranchRangeSelectionViewModel$1_$reflection(Visualization_UnifiedDistanceBranch_$reflection()), float64_type)]], [["Item1", MeasurementInfo_$reflection()], ["Item2", tuple_type(UnifiedBranchAngleSelectionViewModel$1_$reflection(Visualization_UnifiedDistanceBranch_$reflection()), float64_type)]], [["Item1", MeasurementInfo_$reflection()], ["Item2", CArmAngleViewModel_$reflection()]]]);
}

export function StentMeasurement__get_centerlineMeasurement(this$) {
    let matchResult, x;
    switch (this$.tag) {
        case 1: {
            matchResult = 0;
            x = this$.fields[1];
            break;
        }
        case 2: {
            matchResult = 0;
            x = this$.fields[1];
            break;
        }
        case 3: {
            matchResult = 1;
            break;
        }
        case 4: {
            matchResult = 2;
            break;
        }
        case 5: {
            matchResult = 3;
            break;
        }
        default: {
            matchResult = 0;
            x = this$.fields[1];
        }
    }
    switch (matchResult) {
        case 0:
            return new CenterlineMeasurementValueViewModel(2, [x]);
        case 1:
            return new CenterlineMeasurementValueViewModel(0, [this$.fields[1]]);
        case 2:
            throw new Error("Not implemented");
        default:
            throw new Error("Not implemented");
    }
}

export function StentMeasurement__setName_Z721C83C5(this$, name) {
    switch (this$.tag) {
        case 3: {
            const measurementInfo_1 = this$.fields[0];
            return new StentMeasurement(3, [new LengthMeasurementInfo(name, measurementInfo_1.RelatedMeasurementNames, measurementInfo_1.MeasurementBounds, measurementInfo_1.TopCenterlineType, measurementInfo_1.BottomCenterlineType), this$.fields[1]]);
        }
        case 4: {
            const measurementInfo_2 = this$.fields[0];
            return new StentMeasurement(4, [new MeasurementInfo(name, measurementInfo_2.RelatedMeasurementNames, measurementInfo_2.MeasurementBounds, measurementInfo_2.CenterlineType), this$.fields[1]]);
        }
        case 5: {
            const measurementInfo_3 = this$.fields[0];
            return new StentMeasurement(5, [new MeasurementInfo(name, measurementInfo_3.RelatedMeasurementNames, measurementInfo_3.MeasurementBounds, measurementInfo_3.CenterlineType), this$.fields[1]]);
        }
        case 1: {
            const measurementInfo_4 = this$.fields[0];
            return new StentMeasurement(1, [new OffsetMeasurementInfo(name, measurementInfo_4.MeasurementBounds, measurementInfo_4.OffsetMeasurementName, measurementInfo_4.OffsetAmount, measurementInfo_4.CenterlineType), this$.fields[1]]);
        }
        case 2: {
            const measurementInfo_5 = this$.fields[0];
            return new StentMeasurement(2, [new MidpointMeasurementInfo(name, measurementInfo_5.MeasurementBounds, measurementInfo_5.MidpointBounds, measurementInfo_5.CenterlineType), this$.fields[1]]);
        }
        default: {
            const measurementInfo = this$.fields[0];
            return new StentMeasurement(0, [new MeasurementInfo(name, measurementInfo.RelatedMeasurementNames, measurementInfo.MeasurementBounds, measurementInfo.CenterlineType), this$.fields[1]]);
        }
    }
}

export function StentMeasurement__get_name(this$) {
    let measurementName;
    switch (this$.tag) {
        case 3: {
            measurementName = this$.fields[0].MeasurementName;
            break;
        }
        case 4: {
            measurementName = this$.fields[0].MeasurementName;
            break;
        }
        case 5: {
            measurementName = this$.fields[0].MeasurementName;
            break;
        }
        case 1: {
            measurementName = this$.fields[0].MeasurementName;
            break;
        }
        case 2: {
            measurementName = this$.fields[0].MeasurementName;
            break;
        }
        default:
            measurementName = this$.fields[0].MeasurementName;
    }
    return measurementName;
}

export function StentMeasurement__get_centerlineType(this$) {
    let matchResult, measurementInfo_1;
    switch (this$.tag) {
        case 0: {
            matchResult = 1;
            measurementInfo_1 = this$.fields[0];
            break;
        }
        case 4: {
            matchResult = 1;
            measurementInfo_1 = this$.fields[0];
            break;
        }
        case 5: {
            matchResult = 1;
            measurementInfo_1 = this$.fields[0];
            break;
        }
        case 1: {
            matchResult = 2;
            break;
        }
        case 2: {
            matchResult = 3;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return this$.fields[0].TopCenterlineType;
        case 1:
            return measurementInfo_1.CenterlineType;
        case 2:
            return this$.fields[0].CenterlineType;
        default:
            return this$.fields[0].CenterlineType;
    }
}

export function StentMeasurement_areSliceIndicesEqual(a, b) {
    let matchResult, aVm, bVm, aVm_1, bVm_1;
    switch (a.tag) {
        case 1: {
            if (b.tag === 1) {
                matchResult = 0;
                aVm = a.fields[1][0];
                bVm = b.fields[1][0];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 2: {
            if (b.tag === 2) {
                matchResult = 0;
                aVm = a.fields[1][0];
                bVm = b.fields[1][0];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 0: {
            if (b.tag === 0) {
                matchResult = 0;
                aVm = a.fields[1][0];
                bVm = b.fields[1][0];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        case 3: {
            if (b.tag === 3) {
                matchResult = 1;
                aVm_1 = a.fields[1][0];
                bVm_1 = b.fields[1][0];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return aVm.index === bVm.index;
        case 1:
            if (aVm_1.firstIndex === bVm_1.firstIndex) {
                return aVm_1.secondIndex === bVm_1.secondIndex;
            }
            else {
                return false;
            }
        default:
            return false;
    }
}

export function StentMeasurement_areCArmAnglesEqual(a, b) {
    let matchResult, aVm, bVm;
    if (a.tag === 5) {
        if (b.tag === 5) {
            matchResult = 0;
            aVm = a.fields[1];
            bVm = b.fields[1];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            if (Math.abs(aVm.FirstAngle - bVm.FirstAngle) <= 0.0001) {
                return Math.abs(aVm.SecondAngle - bVm.SecondAngle) <= 0.0001;
            }
            else {
                return false;
            }
        default:
            return false;
    }
}

export function StentMeasurement_getBounds(updater, measurement) {
    const boundsMap = empty_1({
        Compare: compare,
    });
    const tryGetFirstPlaneBounds = (boundsList) => map((bounds) => Bounds_getBoundsFromUpdater(updater, bounds), tryHead(boundsList));
    let matchResult, _measurementInfo;
    switch (measurement.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            break;
        }
        case 3: {
            matchResult = 3;
            break;
        }
        case 4: {
            matchResult = 4;
            _measurementInfo = measurement.fields[0];
            break;
        }
        case 5: {
            matchResult = 4;
            _measurementInfo = measurement.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            const bounds_1 = tryGetFirstPlaneBounds(measurement.fields[0].MeasurementBounds);
            if (bounds_1 == null) {
                throw new Error("Unable to get diameter bounds");
            }
            return FSharpMap__Add(boundsMap, new Bindings_PlaneIdentifier(0, []), value_1(bounds_1));
        }
        case 1: {
            const bounds_2 = tryGetFirstPlaneBounds(measurement.fields[0].MeasurementBounds);
            if (bounds_2 == null) {
                throw new Error("Unable to get offset diameter bounds");
            }
            return FSharpMap__Add(boundsMap, new Bindings_PlaneIdentifier(0, []), value_1(bounds_2));
        }
        case 2: {
            const bounds_3 = tryGetFirstPlaneBounds(measurement.fields[0].MeasurementBounds);
            if (bounds_3 == null) {
                throw new Error("Unable to get midpoint diameter bounds");
            }
            return FSharpMap__Add(boundsMap, new Bindings_PlaneIdentifier(0, []), value_1(bounds_3));
        }
        case 3: {
            const measurementInfo_3 = measurement.fields[0];
            const firstPlaneBounds = tryGetFirstPlaneBounds(measurementInfo_3.MeasurementBounds);
            if (firstPlaneBounds == null) {
                throw new Error("Unable to get first plane length bounds");
            }
            return FSharpMap__Add(FSharpMap__Add(boundsMap, new Bindings_PlaneIdentifier(0, []), value_1(firstPlaneBounds)), new Bindings_PlaneIdentifier(1, []), value_1(orElse(map((bounds_4) => Bounds_getBoundsFromUpdater(updater, bounds_4), tryItem(1, measurementInfo_3.MeasurementBounds)), firstPlaneBounds)));
        }
        default:
            return boundsMap;
    }
}

export function StentMeasurement_update(measurement, value) {
    let matchResult, measurementInfo, vm, measurementInfo_1, vm_1, measurementInfo_2, vm_2, measurementInfo_3, vm_3;
    switch (measurement.tag) {
        case 0: {
            if (value.tag === 2) {
                matchResult = 0;
                measurementInfo = measurement.fields[0];
                vm = value.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 1: {
            if (value.tag === 2) {
                matchResult = 1;
                measurementInfo_1 = measurement.fields[0];
                vm_1 = value.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 2: {
            if (value.tag === 2) {
                matchResult = 2;
                measurementInfo_2 = measurement.fields[0];
                vm_2 = value.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        case 3: {
            if (value.tag === 0) {
                matchResult = 3;
                measurementInfo_3 = measurement.fields[0];
                vm_3 = value.fields[0];
            }
            else {
                matchResult = 4;
            }
            break;
        }
        default:
            matchResult = 4;
    }
    switch (matchResult) {
        case 0:
            return new StentMeasurement(0, [measurementInfo, vm]);
        case 1:
            return new StentMeasurement(1, [measurementInfo_1, vm_1]);
        case 2:
            return new StentMeasurement(2, [measurementInfo_2, vm_2]);
        case 3:
            return new StentMeasurement(3, [measurementInfo_3, vm_3]);
        default:
            throw new Error("Invalid measurement and value combination.");
    }
}

export class RelatedStentMeasurement extends Record {
    constructor(Measurement, UpdateIndex) {
        super();
        this.Measurement = Measurement;
        this.UpdateIndex = UpdateIndex;
    }
}

export function RelatedStentMeasurement_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.RelatedStentMeasurement", [], RelatedStentMeasurement, () => [["Measurement", StentMeasurement_$reflection()], ["UpdateIndex", lambda_type(Bindings_PlaneIdentifier_$reflection(), lambda_type(int32_type, lambda_type(StentMeasurement_$reflection(), StentMeasurement_$reflection())))]]);
}

export class SimplifiedStentMeasurements extends Record {
    constructor(Renal, RenalPlus5, RenalPlus10, RenalPlus15, RenalPlus20, NeckDiameter, NeckLength, Bifurc, Right, RCIA, RCIAMid, RCIAMinus20, RCIAMinus10, RCIADist, RCIALength, REIA, REIAMid, REIAMin, REIADist, BoaLength, BoaDiameter, BoaDiameterMax, BoaDiameterBif, Left, LCIA, LCIAMid, LCIAMinus20, LCIAMinus10, LCIADist, LCIALength, LEIA, LEIAMid, LEIAMin, LEIADist, RenalCArmAzimuth, RenalCArmElevation, LIIACArmAzimuth, LIIACArmElevation, RIIACArmAzimuth, RIIACArmElevation) {
        super();
        this.Renal = Renal;
        this.RenalPlus5 = RenalPlus5;
        this.RenalPlus10 = RenalPlus10;
        this.RenalPlus15 = RenalPlus15;
        this.RenalPlus20 = RenalPlus20;
        this.NeckDiameter = NeckDiameter;
        this.NeckLength = NeckLength;
        this.Bifurc = Bifurc;
        this.Right = Right;
        this.RCIA = RCIA;
        this.RCIAMid = RCIAMid;
        this.RCIAMinus20 = RCIAMinus20;
        this.RCIAMinus10 = RCIAMinus10;
        this.RCIADist = RCIADist;
        this.RCIALength = RCIALength;
        this.REIA = REIA;
        this.REIAMid = REIAMid;
        this.REIAMin = REIAMin;
        this.REIADist = REIADist;
        this.BoaLength = BoaLength;
        this.BoaDiameter = BoaDiameter;
        this.BoaDiameterMax = BoaDiameterMax;
        this.BoaDiameterBif = BoaDiameterBif;
        this.Left = Left;
        this.LCIA = LCIA;
        this.LCIAMid = LCIAMid;
        this.LCIAMinus20 = LCIAMinus20;
        this.LCIAMinus10 = LCIAMinus10;
        this.LCIADist = LCIADist;
        this.LCIALength = LCIALength;
        this.LEIA = LEIA;
        this.LEIAMid = LEIAMid;
        this.LEIAMin = LEIAMin;
        this.LEIADist = LEIADist;
        this.RenalCArmAzimuth = RenalCArmAzimuth;
        this.RenalCArmElevation = RenalCArmElevation;
        this.LIIACArmAzimuth = LIIACArmAzimuth;
        this.LIIACArmElevation = LIIACArmElevation;
        this.RIIACArmAzimuth = RIIACArmAzimuth;
        this.RIIACArmElevation = RIIACArmElevation;
    }
}

export function SimplifiedStentMeasurements_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.SimplifiedStentMeasurements", [], SimplifiedStentMeasurements, () => [["Renal", float64_type], ["RenalPlus5", float64_type], ["RenalPlus10", float64_type], ["RenalPlus15", float64_type], ["RenalPlus20", float64_type], ["NeckDiameter", float64_type], ["NeckLength", float64_type], ["Bifurc", float64_type], ["Right", float64_type], ["RCIA", float64_type], ["RCIAMid", float64_type], ["RCIAMinus20", float64_type], ["RCIAMinus10", float64_type], ["RCIADist", float64_type], ["RCIALength", float64_type], ["REIA", float64_type], ["REIAMid", float64_type], ["REIAMin", float64_type], ["REIADist", float64_type], ["BoaLength", float64_type], ["BoaDiameter", float64_type], ["BoaDiameterMax", float64_type], ["BoaDiameterBif", float64_type], ["Left", float64_type], ["LCIA", float64_type], ["LCIAMid", float64_type], ["LCIAMinus20", float64_type], ["LCIAMinus10", float64_type], ["LCIADist", float64_type], ["LCIALength", float64_type], ["LEIA", float64_type], ["LEIAMid", float64_type], ["LEIAMin", float64_type], ["LEIADist", float64_type], ["RenalCArmAzimuth", float64_type], ["RenalCArmElevation", float64_type], ["LIIACArmAzimuth", float64_type], ["LIIACArmElevation", float64_type], ["RIIACArmAzimuth", float64_type], ["RIIACArmElevation", float64_type]]);
}

export function SimplifiedStentMeasurements_fromStentMeasurements_2650BC81(measurements) {
    const getFromDiameters = (name, picker, local) => defaultArg(map((arg_1) => (new FSharpResult$2(0, [round(picker(arg_1), 1, 1)])), local.stentPlanningDiameters), new FSharpResult$2(1, [new ErrorMessage(40, [name])]));
    const getDiameter = (name_5) => {
        let _arg;
        const pick = endsWith(name_5, "Min") ? ((name_2) => ((local_2) => getFromDiameters(name_2, (d_1) => d_1.min, local_2))) : (endsWith(name_5, "Max") ? ((name_3) => ((local_3) => getFromDiameters(name_3, (d_2) => d_2.max, local_3))) : ((name_1) => ((local_1) => getFromDiameters(name_1, (d) => d.average, local_1))));
        const matchValue = FSharpMap__TryFind(measurements, name_5);
        if (matchValue != null) {
            const m = matchValue;
            return Result_bind()(pick(name_5))((_arg = m, (_arg.tag === 0) ? (new FSharpResult$2(0, [_arg.fields[1][1]])) : ((_arg.tag === 1) ? (new FSharpResult$2(0, [_arg.fields[1][1]])) : ((_arg.tag === 2) ? (new FSharpResult$2(0, [_arg.fields[1][1]])) : (new FSharpResult$2(1, [new ErrorMessage(39, [name_5, "Diameter", "StentMeasurement"])]))))));
        }
        else {
            return new FSharpResult$2(1, [new ErrorMessage(38, [name_5])]);
        }
    };
    const getLength = (name_6) => {
        const matchValue_1 = FSharpMap__TryFind(measurements, name_6);
        if (matchValue_1 == null) {
            return new FSharpResult$2(1, [new ErrorMessage(38, [name_6])]);
        }
        else if (matchValue_1.tag === 3) {
            const _lVm = matchValue_1.fields[1][0];
            const l = matchValue_1.fields[1][1];
            return new FSharpResult$2(0, [round(l, 1, 1)]);
        }
        else {
            const other_1 = matchValue_1;
            return new FSharpResult$2(1, [new ErrorMessage(39, [name_6, "Length", "StentMeasurement"])]);
        }
    };
    const getCArmAngle = (name_7) => {
        const matchValue_2 = FSharpMap__TryFind(measurements, name_7);
        if (matchValue_2 == null) {
            return new FSharpResult$2(1, [new ErrorMessage(38, [name_7])]);
        }
        else if (matchValue_2.tag === 5) {
            const vm = matchValue_2.fields[1];
            return new FSharpResult$2(0, [vm]);
        }
        else {
            const other_2 = matchValue_2;
            return new FSharpResult$2(1, [new ErrorMessage(39, [name_7, "CArmAngle", "StentMeasurement"])]);
        }
    };
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("Renal"), (_arg_1) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RenalPlus5"), (_arg_2) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RenalPlus10"), (_arg_3) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RenalPlus15"), (_arg_4) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RenalPlus20"), (_arg_5) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("NeckDiameter"), (_arg_6) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("NeckLength"), (_arg_7) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("Bifurc"), (_arg_8) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("Right"), (_arg_9) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RCIA"), (_arg_10) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RCIAMid"), (_arg_11) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RCIAMinus20"), (_arg_12) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RCIAMinus10"), (_arg_13) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("RCIADist"), (_arg_14) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("RCIALength"), (_arg_15) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("REIA"), (_arg_16) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("REIAMid"), (_arg_17) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("REIAMin"), (_arg_18) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("REIADist"), (_arg_19) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("BoaLength"), (_arg_20) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("BoaDiameter"), (_arg_21) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("BoaDiameterMax"), (_arg_22) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("BoaDiameterBif"), (_arg_23) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("Left"), (_arg_24) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LCIA"), (_arg_25) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LCIAMid"), (_arg_26) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LCIAMinus20"), (_arg_27) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LCIAMinus10"), (_arg_28) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LCIADist"), (_arg_29) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getLength("LCIALength"), (_arg_30) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LEIA"), (_arg_31) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LEIAMid"), (_arg_32) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LEIAMin"), (_arg_33) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getDiameter("LEIADist"), (_arg_34) => ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getCArmAngle("RenalCArm"), (_arg_35) => {
        const renalCArm = _arg_35;
        return ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getCArmAngle("LIIACArm"), (_arg_36) => {
            const liiaCArm = _arg_36;
            return ResultComputationExpression_ResultBuilder__Bind_764BA1D3(ResultComputationExpression_result, getCArmAngle("RIIACArm"), (_arg_37) => {
                const riiaCArm = _arg_37;
                return ResultComputationExpression_ResultBuilder__Return_1505(ResultComputationExpression_result, new SimplifiedStentMeasurements(_arg_1, _arg_2, _arg_3, _arg_4, _arg_5, _arg_6, _arg_7, _arg_8, _arg_9, _arg_10, _arg_11, _arg_12, _arg_13, _arg_14, _arg_15, _arg_16, _arg_17, _arg_18, _arg_19, _arg_20, _arg_21, _arg_22, _arg_23, _arg_24, _arg_25, _arg_26, _arg_27, _arg_28, _arg_29, _arg_30, _arg_31, _arg_32, _arg_33, _arg_34, round(Common_floatToDegrees(renalCArm.FirstAngle), 0, 1), round(Common_floatToDegrees(renalCArm.SecondAngle), 0, 1), round(Common_floatToDegrees(liiaCArm.FirstAngle), 0, 1), round(Common_floatToDegrees(liiaCArm.SecondAngle), 0, 1), round(Common_floatToDegrees(riiaCArm.FirstAngle), 0, 1), round(Common_floatToDegrees(riiaCArm.SecondAngle), 0, 1)));
            });
        });
    })))))))))))))))))))))))))))))))))))));
}

export class StentMeasurementsModule_LengthIndex extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["First", "Second"];
    }
}

export function StentMeasurementsModule_LengthIndex_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.SharedTypes.StentMeasurementsModule.LengthIndex", [], StentMeasurementsModule_LengthIndex, () => [[], []]);
}

function StentMeasurementsModule_updateLengthMeasurement(currentMeasurement, planeIdentifier, index, measurement, targetLengthIndex) {
    if (measurement.tag === 3) {
        const vm = measurement.fields[0];
        const lVm = measurement.fields[1][0];
        const l = measurement.fields[1][1];
        let matchResult;
        switch (currentMeasurement.tag) {
            case 0: {
                if (targetLengthIndex.tag === 1) {
                    matchResult = 1;
                }
                else {
                    matchResult = 0;
                }
                break;
            }
            case 3: {
                switch (planeIdentifier.tag) {
                    case 0: {
                        if (targetLengthIndex.tag === 0) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 4;
                        }
                        break;
                    }
                    case 1: {
                        if (targetLengthIndex.tag === 1) {
                            matchResult = 3;
                        }
                        else {
                            matchResult = 4;
                        }
                        break;
                    }
                    default:
                        matchResult = 4;
                }
                break;
            }
            default:
                matchResult = 4;
        }
        switch (matchResult) {
            case 0:
                return new StentMeasurement(3, [vm, [new UnifiedBranchRangeSelectionViewModel$1(lVm.branch, index, lVm.secondIndex), l]]);
            case 1:
                return new StentMeasurement(3, [vm, [new UnifiedBranchRangeSelectionViewModel$1(lVm.branch, lVm.firstIndex, index), l]]);
            case 2:
                return new StentMeasurement(3, [vm, [new UnifiedBranchRangeSelectionViewModel$1(lVm.branch, index, lVm.secondIndex), l]]);
            case 3:
                return new StentMeasurement(3, [vm, [new UnifiedBranchRangeSelectionViewModel$1(lVm.branch, lVm.firstIndex, index), l]]);
            default:
                return measurement;
        }
    }
    else {
        throw new Error(`Expected Length, but got ${measurement}`);
    }
}

function StentMeasurementsModule_updateOffsetDiameter(measurements, measurementName, activeMeasurement, idx, measurement) {
    if (measurement.tag === 1) {
        const vm = measurement.fields[0];
        if ((equals(vm.OffsetMeasurementName, measurementName) ? activeMeasurement : bind((key) => FSharpMap__TryFind(measurements, key), vm.OffsetMeasurementName)) != null) {
            return new StentMeasurement(1, [vm, [new UnifiedTransitionBranchPointSelectionViewModel(measurement.fields[1][0].branch, idx + vm.OffsetAmount), measurement.fields[1][1]]]);
        }
        else {
            return measurement;
        }
    }
    else {
        throw new Error(`Expected OffsetDiameter, but got ${measurement}`);
    }
}

function StentMeasurementsModule_updateMidpointDiameter(measurements, idx, measurement, planeIdentifier) {
    let offsetMi, topDvm, topDvm_1, bottomDvm, offsetMi_1, bottomDvm_1;
    if (measurement.tag === 2) {
        const vm = measurement.fields[0];
        const maybeMidpointTop = bind((key) => FSharpMap__TryFind(measurements, key), tryHead(vm.MidpointBounds));
        const maybeMidpointBottom = bind((key_1) => FSharpMap__TryFind(measurements, key_1), tryItem(1, vm.MidpointBounds));
        const maybeTopIndex = (maybeMidpointTop != null) ? ((maybeMidpointTop.tag === 1) ? ((offsetMi = maybeMidpointTop.fields[0], (topDvm = maybeMidpointTop.fields[1][0], equals(planeIdentifier, new Bindings_PlaneIdentifier(0, [])) ? (idx + offsetMi.OffsetAmount) : topDvm.index))) : ((maybeMidpointTop.tag === 0) ? ((topDvm_1 = maybeMidpointTop.fields[1][0], equals(planeIdentifier, new Bindings_PlaneIdentifier(0, [])) ? idx : topDvm_1.index)) : undefined)) : undefined;
        const maybeBottomIndex = (maybeMidpointBottom != null) ? ((maybeMidpointBottom.tag === 1) ? ((bottomDvm = maybeMidpointBottom.fields[1][0], (offsetMi_1 = maybeMidpointBottom.fields[0], equals(planeIdentifier, new Bindings_PlaneIdentifier(1, [])) ? (idx + offsetMi_1.OffsetAmount) : bottomDvm.index))) : ((maybeMidpointBottom.tag === 0) ? ((bottomDvm_1 = maybeMidpointBottom.fields[1][0], equals(planeIdentifier, new Bindings_PlaneIdentifier(1, [])) ? idx : bottomDvm_1.index)) : undefined)) : undefined;
        let matchResult, bottomIndex, topIndex;
        if (maybeTopIndex != null) {
            if (maybeBottomIndex != null) {
                matchResult = 0;
                bottomIndex = maybeBottomIndex;
                topIndex = maybeTopIndex;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new StentMeasurement(2, [vm, [new UnifiedTransitionBranchPointSelectionViewModel(measurement.fields[1][0].branch, (topIndex === bottomIndex) ? topIndex : (~~(Math.abs(bottomIndex - topIndex) / 2) + min(topIndex, bottomIndex))), measurement.fields[1][1]]]);
            default:
                return measurement;
        }
    }
    else {
        throw new Error(`Expected MidpointDiameter, but got ${measurement}`);
    }
}

export function StentMeasurementsModule_getRelatedMeasurementsWithMapper(measurements, measurement) {
    return ofList((measurement.tag === 3) ? append(collect((name) => {
        const matchValue = FSharpMap__TryFind(measurements, name);
        if (matchValue == null) {
            return empty();
        }
        else {
            const relatedMeasurement = matchValue;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(0, []))}-${name}`, new RelatedStentMeasurement(relatedMeasurement, (planeIdentifier, idx, m) => ((planeIdentifier.tag === 0) ? ((m.tag === 0) ? (new StentMeasurement(0, [m.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m.fields[1][0].branch, idx), m.fields[1][1]]])) : ((m.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx, m) : ((m.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : m))) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)))) : ((measurement.tag === 0) ? ((m.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.FirstPlaneNames), append(collect((name_1) => {
        const matchValue_2 = FSharpMap__TryFind(measurements, name_1);
        if (matchValue_2 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_1 = matchValue_2;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(1, []))}-${name_1}`, new RelatedStentMeasurement(relatedMeasurement_1, (planeIdentifier_1, idx_1, m_2) => ((planeIdentifier_1.tag === 1) ? ((m_2.tag === 0) ? (new StentMeasurement(0, [m_2.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_2.fields[1][0].branch, idx_1), m_2.fields[1][1]]])) : ((m_2.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx_1, m_2) : ((m_2.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : m_2))) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)))) : ((measurement.tag === 0) ? ((m_2.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.SecondPlaneNames), collect((name_2) => {
        const matchValue_4 = FSharpMap__TryFind(measurements, name_2);
        if (matchValue_4 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_2 = matchValue_4;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(2, []))}-${name_2}`, new RelatedStentMeasurement(relatedMeasurement_2, (_planeIdentifier, idx_2, m_4) => ((m_4.tag === 0) ? (new StentMeasurement(0, [m_4.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_4.fields[1][0].branch, idx_2), m_4.fields[1][1]]])) : m_4))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.ThirdPlaneNames))) : ((measurement.tag === 4) ? append(collect((name) => {
        const matchValue = FSharpMap__TryFind(measurements, name);
        if (matchValue == null) {
            return empty();
        }
        else {
            const relatedMeasurement = matchValue;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(0, []))}-${name}`, new RelatedStentMeasurement(relatedMeasurement, (planeIdentifier, idx, m) => ((planeIdentifier.tag === 0) ? ((m.tag === 0) ? (new StentMeasurement(0, [m.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m.fields[1][0].branch, idx), m.fields[1][1]]])) : ((m.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx, m) : ((m.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : m))) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)))) : ((measurement.tag === 0) ? ((m.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.FirstPlaneNames), append(collect((name_1) => {
        const matchValue_2 = FSharpMap__TryFind(measurements, name_1);
        if (matchValue_2 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_1 = matchValue_2;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(1, []))}-${name_1}`, new RelatedStentMeasurement(relatedMeasurement_1, (planeIdentifier_1, idx_1, m_2) => ((planeIdentifier_1.tag === 1) ? ((m_2.tag === 0) ? (new StentMeasurement(0, [m_2.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_2.fields[1][0].branch, idx_1), m_2.fields[1][1]]])) : ((m_2.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx_1, m_2) : ((m_2.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : m_2))) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)))) : ((measurement.tag === 0) ? ((m_2.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.SecondPlaneNames), collect((name_2) => {
        const matchValue_4 = FSharpMap__TryFind(measurements, name_2);
        if (matchValue_4 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_2 = matchValue_4;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(2, []))}-${name_2}`, new RelatedStentMeasurement(relatedMeasurement_2, (_planeIdentifier, idx_2, m_4) => ((m_4.tag === 0) ? (new StentMeasurement(0, [m_4.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_4.fields[1][0].branch, idx_2), m_4.fields[1][1]]])) : m_4))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.ThirdPlaneNames))) : ((measurement.tag === 1) ? empty() : ((measurement.tag === 2) ? empty() : ((measurement.tag === 5) ? empty() : append(collect((name) => {
        const matchValue = FSharpMap__TryFind(measurements, name);
        if (matchValue == null) {
            return empty();
        }
        else {
            const relatedMeasurement = matchValue;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(0, []))}-${name}`, new RelatedStentMeasurement(relatedMeasurement, (planeIdentifier, idx, m) => ((planeIdentifier.tag === 0) ? ((m.tag === 0) ? (new StentMeasurement(0, [m.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m.fields[1][0].branch, idx), m.fields[1][1]]])) : ((m.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx, m) : ((m.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : m))) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)))) : ((measurement.tag === 0) ? ((m.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx, m, new Bindings_PlaneIdentifier(0, [])) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m)) : ((m.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier, idx, m, new StentMeasurementsModule_LengthIndex(0, [])) : m))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.FirstPlaneNames), append(collect((name_1) => {
        const matchValue_2 = FSharpMap__TryFind(measurements, name_1);
        if (matchValue_2 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_1 = matchValue_2;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(1, []))}-${name_1}`, new RelatedStentMeasurement(relatedMeasurement_1, (planeIdentifier_1, idx_1, m_2) => ((planeIdentifier_1.tag === 1) ? ((m_2.tag === 0) ? (new StentMeasurement(0, [m_2.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_2.fields[1][0].branch, idx_1), m_2.fields[1][1]]])) : ((m_2.tag === 1) ? StentMeasurementsModule_updateOffsetDiameter(measurements, measurement.fields[0].MeasurementName, measurement, idx_1, m_2) : ((m_2.tag === 2) ? ((measurement.tag === 3) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 4) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((measurement.tag === 0) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : m_2))) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)))) : ((measurement.tag === 0) ? ((m_2.tag === 2) ? StentMeasurementsModule_updateMidpointDiameter(measurements, idx_1, m_2, new Bindings_PlaneIdentifier(1, [])) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2)) : ((m_2.tag === 3) ? StentMeasurementsModule_updateLengthMeasurement(measurement, planeIdentifier_1, idx_1, m_2, new StentMeasurementsModule_LengthIndex(1, [])) : m_2))))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.SecondPlaneNames), collect((name_2) => {
        const matchValue_4 = FSharpMap__TryFind(measurements, name_2);
        if (matchValue_4 == null) {
            return empty();
        }
        else {
            const relatedMeasurement_2 = matchValue_4;
            return singleton([`${Bindings_PlaneIdentifier_Id_Z3EBB1C36(new Bindings_PlaneIdentifier(2, []))}-${name_2}`, new RelatedStentMeasurement(relatedMeasurement_2, (_planeIdentifier, idx_2, m_4) => ((m_4.tag === 0) ? (new StentMeasurement(0, [m_4.fields[0], [new UnifiedTransitionBranchPointSelectionViewModel(m_4.fields[1][0].branch, idx_2), m_4.fields[1][1]]])) : m_4))]);
        }
    }, measurement.fields[0].RelatedMeasurementNames.ThirdPlaneNames))))))), {
        Compare: comparePrimitives,
    });
}

